import { useQuery } from '@tanstack/react-query';
import { request } from 'javascripts/services/v3ApiClient';
import type {
  V3ApiSuccessfulResponse,
  V3ApiFailedResponse,
} from 'javascripts/services/v3ApiClient';

export type GetGoogleIdAlreadyUsedResponse = V3ApiSuccessfulResponse<{
  alreadyUsed: boolean;
}>;

export const useGetGoogleIdAlreadyUsed = (googlePlaceId?: string) => {
  return useQuery<GetGoogleIdAlreadyUsedResponse, V3ApiFailedResponse>({
    queryFn: async () => {
      let idAlreadyUsed = true;
      try {
        await request({
          url: `/companies/public_profiles/google_company/${googlePlaceId}`,
        });
      } catch (error) {
        // when a company can't be found by a google place id, it returns a 404. This is the success
        // state that allows a company to continue onboarding to create a company with that place id,
        // thus the error handling here.
        // Rather the complexity in this hook than the consumer needing to know the nuances.
        if (error.errors[0]?.status === '404') {
          idAlreadyUsed = false;
        } else {
          throw error;
        }
      }
      return {
        data: {
          alreadyUsed: idAlreadyUsed,
        },
        errors: [],
        meta: {
          hasNextPage: false,
          nextPage: null,
          hasPreviousPage: false,
          previousPage: null,
        },
      };
    },
    queryKey: ['TRUSTY_GOOGLE_ID_ALREADY_USED', googlePlaceId],
    enabled: !!googlePlaceId,
  });
};
